<template>
  <div class="all-wrapper menu-side with-pattern" id="app-login">
    <div class="auth-box-w">
      <div class="logo-w" style="padding: 10% 20%;">
        <div class="animated-logo">
          <a href="index.html">
            <img alt src="/logo.png" style="width: 100%;">
          </a>
        </div>
      </div>
      <h4 class="auth-header">Inicio de Sesión</h4>
      <form method="post" @submit="login">
        <div id="div_id_username" class="form-group">
          <i class="fas fa-user-circle"></i>
          &nbsp;
          <label for="id_username" class="col-form-label requiredField">
             Usuario
            <span class="asteriskField">*</span>
          </label>
          <div>
            <input v-model="username" type="text" name="username" autofocus="autofocus" required="required"
              id="id_username" class="textinput textInput form-control">
            <small class="form-text text-danger">{{ errors.username[0] }}</small>
          </div>
        </div>
        <div id="div_id_password" class="form-group">
          <i class="fas fa-key"></i>
          &nbsp;
          <label for="id_password" class="col-form-label requiredField">
            Contraseña
            <span class="asteriskField">*</span>
          </label>
          <div>
            <input type="password" v-model="password" name="password" required="required" id="id_password"
              class="textinput textInput form-control">
            <small class="form-text text-danger">{{ errors.password[0] }}</small>
          </div>
          <br>
          <div class="center-button">
            <label class="form-check-label">
              <input type="checkbox" class="form-check-input">Recuérdame
            </label>
          </div>
          <br>
        </div>
        <div class="buttons-w">
          <div class="center-button">
            <small v-if="errors.non_field_errors" class="form-text text-danger">{{ errors.non_field_errors[0] }}</small>
            <button type="submit" class="btn btn-primary">Entrar</button>
            <div class="form-check-inline">
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AuthService from "@/services/AuthService";

export default {
  data() {
    return {
      username: "",
      password: "",
      errors: {
        username: [],
        password: [],
        non_field_errors: []
      }
    };
  },
  components: {},
  beforeMount() {
    this.$store.commit("SET_LAYOUT", "clean-layout");
  },
  methods: {
    async login(e) {
      e.preventDefault();
      let self = this;
      this.$data.errors = {
        username: [],
        password: [],
        non_field_errors: []
      };

      await AuthService.login({
        username: this.$data.username,
        password: this.$data.password
      })
        .then(res => {
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("username", res.data.username);
          localStorage.setItem("name", res.data.name);
          localStorage.setItem("email", res.data.email);
          localStorage.setItem("image", res.data.image);
          localStorage.setItem("id_usuario", res.data.id);
          localStorage.setItem("is_superuser", res.data.is_superuser);
          localStorage.setItem("tipo_usuario", res.data.tipo_usuario);
          localStorage.setItem("permisos", JSON.stringify(res.data.permisos));
          const hhusers = [
            "PICKEADOR",
            "REVISOR_ESTACION",
            "BODEGUERO",
            "PASILLO",
            "USUARIO_CEDIS",
          ];
          if (hhusers.includes(res.data.tipo_usuario)) {
            self.$store.commit("SET_LAYOUT", "hh-layout");
          } else {
            self.$store.commit("SET_LAYOUT", "app-layout");
          }
          self.$store.commit("SET_MODULE", "dashboard");
          let nexturl = localStorage.getItem("nexturl");
          if (!nexturl) {
            nexturl = '/';
          }
          window.location.href = nexturl;
          // this.$router.push({ name: "dashboard" });
        })
        .catch(err => {
          Object.assign(this.errors, err.response.data);
        });
    }
  }
};
</script>
<style>
.fade-in-image {
  animation: fadeIn 4s;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-ms-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.center-button {
  text-align: center;
}

.button {
  position: absolute;
  top: 50%;
}
</style>
